import HeaderExtranet from './HeaderExtranet.container';

export default HeaderExtranet;
